<template >
  <div v-if="element.visible">
    <graphic-element
      v-for="el in childElements"
      v-bind="$attrs"
      :key="el.id"
      ref="child"
      :element="el"
      :graphic="graphic"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'LinkedData',
  inject: [
    'providerData',
  ],
  props: {
    element: {
      type: Object,
      required: true,
    },

    graphic: {
      type: Object,
      required: true,
    },

    customLabels: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    GraphicElement: defineAsyncComponent(() => import('./render-elements')), // eslint-disable-line
  },
  computed: {
    childElements() {
      return this.element.elements.slice().reverse();
    },
  },
};
</script>

<style>

</style>
